import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/*
 * Used to show the summary for products others than Seats. Products
 * that have a simple way to show the summary as a comma separated
 * list of items that sometimes have a quantity */
@Component({
  selector: 'fin-included-product-item-summary-other',
  templateUrl: './included-product-item-summary-other.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncludedProductItemSummaryOtherComponent {
  @Input()
  summary: { quantity?: number; description: string }[];
}
